<!-- /src/components/Bio/ContactChip.vue -->
<template>
  <div class="bio-chip">
    <div
      class="bio-chip__image"
      :class="{ 'bio-chip__image--noProfileImg': !profileImage }"
      :style="profileImage"
    >
      <i class="icon fal fa-users"></i>
    </div>
    <div class="bio-chip__details">
      <h4 class="bio-chip__details__name">{{ authorName }}</h4>
      <div class="bio-chip__details__title" v-if="authorContact">
        <a
          v-if="authorContact['email']"
          class="bio-chip__details__contact-email button button--accent"
          :href="'mailto:' + authorContact['email']"
        >
          <span>{{ authorContact['email'] }}</span>
        </a>
        <br v-if="authorContact['email'] && authorContact['phone']" />
        <a
          v-if="authorContact['phone']"
          class="bio-chip__details__contact-phone button button--accent"
          :href="'tel:' + authorContact['phone']"
        >
          <span>{{ authorContact['phone'] }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['bio'],
  data() {
    return {}
  },

  computed: {
    authorName() {
      return this.bio.name
    },
    profileImage() {
      const { acf } = this.bio
      return acf && acf.bio_image
        ? `background-image: url(${acf.bio_image.sizes.thumbnail});`
        : ''
    },
    authorContact() {
      const { acf } = this.bio
      if (acf) {
        const { contact } = acf
        if (typeof contact.email == 'undefined' || contact.email == '')
          contact['email'] =
            this.bio.name.toLowerCase().replace(' ', '.') + '@carr.us'
        return contact ? contact : false
      }
      return false
    },
  },
}
</script>

<style scoped>
.bio-chip {
  display: flex;
  align-items: stretch;
  height: 65px;

  &__details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    padding: 0.5rem 0.25rem 0.5rem 0.5rem;

    @media (--desktop-large) {
      padding: 0.5rem 0.5rem 0.5rem 1rem;
    }

    &__name {
      margin: 0;
      font-weight: 500;
      color: var(--brandPrimary);
      font-size: 0.8rem;
    }

    &__title {
      font-size: 0.6rem;
      /* font-style: italic; */

      a {
        display: inline-block;
        padding: 0.5em 0.75em;
        text-transform: lowercase;
        margin-bottom: 0.25em;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  &__image {
    width: 65px;
    background-size: cover;
    border-radius: 50%;
    background-color: var(--gray);
    line-height: 65px;
    text-align: center;
    color: white;
    font-size: 2rem;
    user-select: none;

    & .icon {
      opacity: 0;
    }

    &--noProfileImg {
      & .icon {
        opacity: 1;
      }
    }
  }
}
</style>
